<template>
  <div id="app">
    <router-view></router-view>
    <div class="tn-loading" v-show="loading">
      <van-loading/>
    </div>
  </div>
</template>
<script>
  import {setAuthToken, User} from '../../api';

  const curUrl = 'curUrl';

  export default {
    name: 'app',
    data() {
      return {};
    },
    computed: {
      loading() {
        return this.$store.state.loading;
      }
    },
    mounted() {
      //console.log('app page mounted');
      this.setAuthTokenFromQuery();
      this.$router.onReady(() => {
        let path = this.$route.path;
        if (!(path === '/loginDev' || path === '/login' || path === '/test')) {
          this.login();
        }
      });
    },
    watch: {
      '$route.path': function (newPath, oldPath) {
        console.log('route path:', oldPath, '->', newPath);
        if (newPath === '/' && (oldPath === '/loginDev' || oldPath === '/login')) {
          this.login();
        }
      }
    },
    methods: {
      login() {
        this.$showLoading();
        let params = {
          type: this.$store.state.type
        };
        User.login(params).then(res => { //try /getuserinfo, api will return redirect url if 401
            this.onLoginSuccess(res);
          }
        ).catch(e => {
          this.$hideLoading();
          let test = this.$route.query.test;
          let response = e.response;
          //console.log(test);
          if (response && response.status === 401) {
            window.localStorage.setItem(curUrl, window.location.href);
            if (response.data && response.data.url) {
              if (test) {
                this.$router.push('/loginDev');
              } else {
                window.location.href = response.data.url;
              }
            }

          }
        });
      },
      onLoginSuccess(res) {
        let url = window.localStorage.getItem(curUrl);
        if (url) {
          window.location.href = url;
          window.localStorage.removeItem(curUrl);
        }
        this.$hideLoading();
        this.$store.commit('user', res.data);
        this.$store.commit('type', res.data.userType);
        this.queryRoles();
      },
      queryRoles() {
        User.queryRoles().then(res => {
          this.$store.commit('roles', res.data);
        });
      },
      setAuthTokenFromQuery() {
        let queryStr = window.location.search;
        if (queryStr) {
          let ary = queryStr.substr(1) //remove '?'
            .split('&');
          let params = ary.map(m => m.split('='));
          params.forEach(queryKVPair => {
            // 设置type值
            if (queryKVPair[0] === 'type') {
              this.$store.commit('type', queryKVPair[1]);
            }
            // 设置token
            if (queryKVPair[0] === 'token') {
              setAuthToken(queryKVPair[1]);
            }
          });
        }
      }
    }
  };
</script>
